import React from 'react';
//commented out some navs
// Component
import Link from '../Link';
import { Flex, Box } from 'rebass';
import { colors } from '../../tailwind';
// Locale
import Text from '../../components_new/common/Text';
import { Whitespace } from '../../components_new/common';
import styled from 'styled-components';

const footerColor = colors.grayDark;

function Footer() {
  return (
    <NavLinkGroup
      bg="white"
      width="100%"
      style={{
        minHeight: 296,
        borderTop: '0.5px solid ' + colors.coolGrayLight,
        paddingTop: 1,
      }}
      flexDirection="row"
      justifyContent="center"
    >
      <NavLinkGroup
        bg="white"
        width="100%"
        style={{ minHeight: 296, maxWidth: '1000px' }}
        flexDirection="row"
      >
        <Flex
          flex={2}
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <img
            src={'/icons/logo-mark.svg'}
            height={72}
            width="auto"
            style={{ padding: '6px' }}
          />
          <Whitespace />
          <Text large letterSpacing=".2px" style={{ color: footerColor }}>
            support@yoodlize.com
          </Text>
          {
            // <Text large letterSpacing=".2px" style={{ color: footerColor }}>
            //   555.555.5555
            // </Text>
          }
        </Flex>
        <NavLinkGroup flex={5} flexDirection="row">
          <Flex
            flex={1}
            flexDirection="column"
            alignItems="start"
            justifyContent="flex-start"
          >
            <Text
              large
              bold
              style={{ color: footerColor }}
              pt={48}
              letterSpacing="1px"
            >
              NAVIGATION
            </Text>
            <Link to="/">
              <Text
                large
                clickable
                letterSpacing=".2px"
                style={{ color: footerColor }}
                pt={24}
              >
                Home
              </Text>
            </Link>
            <Link to="/s">
              <Text
                large
                clickable
                letterSpacing=".2px"
                style={{ color: footerColor }}
                pt={2}
              >
                Browse
              </Text>
            </Link>
{/*          
            <Link to="/add-listing">
              <Text
                large
                clickable
                letterSpacing=".2px"
                style={{ color: footerColor }}
                pt={2}
              >
                List an item
              </Text>
            </Link> */}
            {/* <Link to="/user/edit">
              <Text
                large
                clickable
                letterSpacing=".2px"
                style={{ color: footerColor }}
                pt={2}
              >
                Profile
              </Text>
            </Link> */}
          
          </Flex>
          <Box flex={0.25} style={{ minWidth: 12 }} /> 
          <Flex
            flex={1}
            flexDirection="column"
            alignItems="start"
            justifyContent="flex-start"
          >
            <Text
              large
              bold
              style={{ color: footerColor }}
              pt={48}
              letterSpacing="1px"
            >
              CATEGORIES
            </Text>
            <Link to="/s?category=86">
              <Text
                large
                clickable
                letterSpacing=".2px"
                style={{ color: footerColor }}
                pt={24}
              >
                Tools
              </Text>
            </Link>
            <Link to="/s?category=84">
              <Text
                large
                clickable
                letterSpacing=".2px"
                style={{ color: footerColor }}
                pt={2}
              >
                Outdoor Gear
              </Text>
            </Link>
            <Link to="/s?category=88">
              <Text
                large
                clickable
                letterSpacing=".2px"
                style={{ color: footerColor }}
                pt={2}
              >
                Party & Wedding Equipment
              </Text>
            </Link>
            <Link to="/s?category=85">
              <Text
                large
                clickable
                letterSpacing=".2px"
                style={{ color: footerColor }}
                pt={2}
              >
                Electronics
              </Text>
            </Link>
          </Flex>
          <Box flex={0.25} style={{ minWidth: 12 }} />
          <Flex
            flex={1}
            flexDirection="column"
            alignItems="start"
            justifyContent="flex-start"
          >
            <Text
              large
              bold
              style={{ color: footerColor }}
              pt={48}
              letterSpacing="1px"
            >
              MORE
            </Text>
            <Link to="/s?category=91">
              <Text
                large
                clickable
                letterSpacing=".2px"
                style={{ color: footerColor }}
                pt={24}
              >
                Recreational Vehicles
              </Text>
            </Link>
            <Link to="/s?category=74">
              <Text
                large
                clickable
                letterSpacing=".2px"
                style={{ color: footerColor }}
                pt={2}
              >
                Clothing
              </Text>
            </Link>
            <Link to="/s?category=77">
              <Text
                large
                clickable
                letterSpacing=".2px"
                style={{ color: footerColor }}
                pt={2}
              >
                Home and Kitchen
              </Text>
            </Link>
            <Link to="/s">
              <Text
                large
                clickable
                letterSpacing=".2px"
                style={{ color: footerColor }}
                pt={2}
              >
                All
              </Text>
            </Link>
          </Flex>
          <Flex
            flex={1.5}
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Flex
              flex={3}
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <Text
                large
                clickable
                bold
                style={{ color: footerColor }}
                letterSpacing="1px"
              >
                CONNECT WITH US
              </Text>
              <Flex>
                <Link to="https://www.facebook.com/yoodlizeInc">
                  <i className="fab fa-facebook pointer" style={iconStyle} />
                </Link>
                <Link to="https://twitter.com/Yoodlize1">
                  <i className="fab fa-twitter-square pointer" style={iconStyle} />
                </Link>
                <Link to="https://www.instagram.com/yoodlizeinc/">
                  <i className="fab fa-instagram pointer" style={iconStyle} />
                </Link>
              </Flex>
            </Flex>
            <Flex flex={1} justifyContent="center" alignItems="center">
              <Text
                large
                clickable
                letterSpacing=".2px"
                style={{ color: footerColor }}
                noclip
              >
                <Link to="/policies">
                  <Text
                    large
                    letterSpacing=".2px"
                    style={{ color: footerColor }}
                    small
                    clickable
                    inline
                  >
                    Terms
                  </Text>
                </Link>{' '}
                &{' '}
                <Link to="/privacy">
                  <Text
                    large
                    letterSpacing=".2px"
                    style={{ color: footerColor }}
                    small
                    clickable
                    inline
                  >
                    Privacy
                  </Text>
                </Link>{' '}
                <i className="fa fa-copyright" /> Yoodlize
              </Text>
            </Flex>
          </Flex>
        </NavLinkGroup>
      </NavLinkGroup>
    </NavLinkGroup>
  );
}

const iconStyle = {
  fontSize: 18,
  color: colors.grayDark,
  margin: 8,
};

export default Footer;

const NavLinkGroup = styled(Flex)`
  @media only screen and (max-width: 700px) {
    flex-wrap: wrap;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js